export default "<body>\r\n<div class=\"container\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n</body>\r\n"